import { Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '../core/store.service';

@Pipe({
  name: 'phoneNumber'
})

export class ConnectionPipe implements PipeTransform {

  constructor(
    protected store: StoreService
  ) { }

  transform(value: string): string {

    value = value.replace(/\./g, '');
    value = value.replace(/\ /g, '');
    let phoneNumber: string = '';

    switch (this.store.AppParams.culture) {

      case 'fr-FR':

        for (let i: number = 0; i < value.length; i++) {
          if (value.substr(0, 1) === '+') {
            if (i === 0 || i === 1 || i === 2) {
              phoneNumber += value.substr(i, 1);
            } else if (i === 3) {
              phoneNumber += ' ' + value.substr(i, 1);
            } else if (value.substr(0, i + 1).length % 2 !== 0) {
              phoneNumber += '.' + value.substr(i, 1);
            } else {
              phoneNumber += value.substr(i, 1);
            }
          } else if (i === 0) {
            phoneNumber += value.substr(i, 1);
          } else if (value.substr(0, i + 1).length % 2 !== 0) {
            phoneNumber += '.' + value.substr(i, 1);
          } else {
            phoneNumber += value.substr(i, 1);
          }
        }
        break;
      case 'en-GB':

        break;
    }
    return phoneNumber;
  }
}
